import React, { Component } from 'react';
import { DataRegionAdministrative } from '../../data/DataRegionAdministrative';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxRegionAdministrative extends Component {

    static defaultProps = {
        filtreSurMonPerimetre: false,
        label: "Région administrative",
        placeholder: "Région administrative",
    };

    render = () => {

        const { filtreSurMonPerimetre } = this.props;

        return <EUIComboBox
            {...this.props}
            fetchMethod={() => DataRegionAdministrative._chargementRegionPerimetreAdministrative(filtreSurMonPerimetre)}
            idValeurParDefaut={null} // En BDD l'id 0 est utilisé par la région administrative "Non renseignée"
            itemKey={item => item.idRegionAdministrative}
            itemText={item => item.regionAdministrative}
        />;

    };

};